import { render, staticRenderFns } from "./AddReviewModal.vue?vue&type=template&id=2eb71802&scoped=true&"
import script from "./AddReviewModal.vue?vue&type=script&lang=js&"
export * from "./AddReviewModal.vue?vue&type=script&lang=js&"
import style0 from "./AddReviewModal.vue?vue&type=style&index=0&id=2eb71802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb71802",
  null
  
)

export default component.exports